import { useTranslation } from 'react-i18next';
import { iFilterInfluencers, iManageFilters } from '../dto/IManageCalendar';
import React, { SetStateAction, useState } from 'react';
import { IContentModal } from '../../../book/offer/dto/IContentModal';
import { Platforms } from '../../../../../../model/platform/Platforms';
import { CustomAutocomplete } from '../../../../../../shared/components/Autocomplete';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../../store/rootReducer';

export interface iFilterPlatforms {
    name?: string;
    page: number;
    isEnabled?: boolean;
    perPage: number;
}

interface iCalendarListViewHeaderProps {
    handleChangeParams: (paramKey: string, paramValue: string | number | string[], isLongTerm?: boolean | null) => void;
    filterParams: iManageFilters;
    platform: Platforms[];
    setFilterPlannerStatus: React.Dispatch<SetStateAction<iManageFilters>>;
}

export const CalendarListViewHeader = ({ ...props }: iCalendarListViewHeaderProps) => {
    const { t } = useTranslation();
    const { offerItemEventsEnum } = useSelector((states: IAllStates) => states.enums);
    const [selectedUser] = useState<IContentModal | undefined>(undefined);
    const selectedPlatform = props.platform?.find(platform => platform?.id === Number(props.filterParams.platformId));

    const changeCreatorsHandler = (paramKey: string, paramValue: string | string[] | number) => {
        props.setFilterPlannerStatus(prev => ({ ...prev, [paramKey]: paramValue, page: 1 }));
    };

    return (
        <div className="row align-items-center justify-content-between flex-column flex-md-row w-100 pt-1 pb-3 mb-3 border-bottom mx-0">
            <div className="col-12 px-0 d-flex align-items-center flex-column">
                <CustomAutocomplete
                    dataArray={offerItemEventsEnum}
                    inputLabel="plannerStatus"
                    isWithImage={false}
                    queryFilterKey="status"
                    disableClearable={false}
                    classes="col-12 px-0"
                    isOfferEnum
                    inputLabelTranslation={t('influencer.planner.filterByStatus')}
                    handleChangeParams={changeCreatorsHandler}
                />
                <CustomAutocomplete
                    dataArray={props.platform?.map(platform => ({
                        ...platform,
                        name: t(`general.platforms.${platform?.name}`),
                    }))}
                    isWithImage={true}
                    inputLabel="name"
                    changeEventKey="name"
                    inputLabelTranslation={t('brand.campaign.manage.postingType')}
                    photoLabel="path"
                    selectedStateImage={selectedPlatform?.path as string}
                    queryFilterKey="platformId"
                    classes="mt-2 col-12 px-0"
                    disableClearable={false}
                    handleChangeParams={(key, value) => {
                        props.handleChangeParams(key, value, selectedUser?.isLongTerm ?? null);
                        props.handleChangeParams('page', 1, selectedUser?.isLongTerm ?? null);
                    }}
                />
            </div>
        </div>
    );
};
